/**
 this page is written on the DetailsSection old component.
 */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Flex } from '@bb/elements-web';

import ListingEntryV2 from 'components/ListingEntryV2';
import { DENIED_STATUSES, TIME_CHANGE_STATUSES } from '../../constants';
import TypeBuyerColumn from './TypeBuyerColumn';
import AvailActionsColumn from './AvailActionsColumn';
import DenyReasonBanner from './DenyReasonBanner';
import PreviousTimeBanner from './PreviousTimeBanner';
import ShowingDetailsContext from '../../ShowingDetailsV2/ShowingDetailsContext';

const ShowingInformationRow: React.FC = () => {
  const { appointment, denyReason, listing, scrollToFeedback, showFeedback } =
    useContext(ShowingDetailsContext);
  return (
    <>
      {TIME_CHANGE_STATUSES.includes(appointment.status) &&
        appointment.originalTime &&
        appointment.originalTimeEnd && (
          <PreviousTimeBanner
            originalTime={appointment.originalTime}
            originalTimeEnd={appointment.originalTimeEnd}
            timezone={listing.timezone}
          />
        )}
      {denyReason && (
        <DenyReasonBanner
          reason={denyReason}
          status={appointment.status as (typeof DENIED_STATUSES)[number]}
        />
      )}
      <StyledRowContainer wrap="wrap" gap="16px">
        <Wrapper $flex={3}>
          <ListingEntryV2
            durationHour={appointment.duration.hours}
            durationMin={appointment.duration.minutes}
            line1={listing.line1}
            line2={listing.line2}
            listingId={listing.id}
            showTimezone
            thumbnail={listing.thumbnail}
            time={appointment.time}
            timeEnd={appointment.timeEnd}
            timezone={listing.timezone}
          />
        </Wrapper>
        <Wrapper $flex={2}>
          <AvailActionsColumn
            showFeedback={showFeedback}
            scrollToFeedback={scrollToFeedback}
          />
        </Wrapper>
        <Wrapper $flex={2}>
          <TypeBuyerColumn />
        </Wrapper>
      </StyledRowContainer>
    </>
  );
};

export default ShowingInformationRow;

const StyledRowContainer = styled(Flex)`
  margin-bottom: 20px;
`;

const Wrapper = styled.div<{ $flex: number }>`
  flex: ${({ $flex }) => $flex};
  min-width: 400px;
`;
